import { render, staticRenderFns } from "./importCateredStudent.vue?vue&type=template&id=9aa6757c&scoped=true&"
import script from "./importCateredStudent.vue?vue&type=script&lang=js&"
export * from "./importCateredStudent.vue?vue&type=script&lang=js&"
import style0 from "./importCateredStudent.vue?vue&type=style&index=0&id=9aa6757c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa6757c",
  null
  
)

export default component.exports